import { Link as FluentLink } from '@fluentui/react';
import { Link } from 'react-router-dom';
import { ContentSection } from '../../components/LayoutElements';

export const NotFound = () => {
    return (
        <ContentSection>
            Oh no! This page does not exist.
            <Link to="/admin">
                <FluentLink>Go back to settings</FluentLink>
            </Link>
        </ContentSection>
    );
};
